import React, { useContext } from "react";
import { FiBell } from "react-icons/fi";

import "./header.css";

import { Context } from "../../utils/context";
const Header = () => {
  const monthArray = [
    "Jan",
    "Feb",
    "March",
    "April",
    "May",
    "June",
    "July",
    "Aug",
    "Sept",
    "Oct",
    "Nov",
    "Dec",
  ];
  const currentYear = new Date().getFullYear();
  const currentMonth = new Date().getMonth();
  const { heading } = useContext(Context);

  return (
    <>
      <div className="header">
        <div className="heading">
          <h3>{heading}</h3>
          <span>
            {monthArray[currentMonth]} {currentYear}
          </span>
        </div>
        <div className="alert">
          <FiBell />
        </div>
      </div>
    </>
  );
};

export default Header;
